export default function() {
  /**
   * SEE https://material.io/resources/icons/?style=baseline for more icons
   */
  return [
    {
      title: "Utilisateurs",
      htmlBefore: '<i class="material-icons">people</i>',
      to: "/users-list",
    },
    {
      title: "Appareils",
      htmlBefore: '<i class="material-icons">settings_input_antenna</i>',
      to: "/devices-list",
    },
    {
      title: "Logout",
      to: "/logout",
      htmlBefore: '<i class="material-icons">exit_to_app</i>',
      htmlAfter: ""
    },
   /* {
      title: "Register",
      to: "/register",
      htmlBefore: '<i class="material-icons">exit_to_app</i>',
      htmlAfter: ""
    },*/
    /*
    ,
    {
      title: "Blog Dashboard",
      to: "/blog-overview",
      htmlBefore: '<i class="material-icons">edit</i>',
      htmlAfter: ""
    },
    {
      title: "Blog Posts",
      htmlBefore: '<i class="material-icons">vertical_split</i>',
      to: "/blog-posts",
    },
    {
      title: "Add New Post",
      htmlBefore: '<i class="material-icons">note_add</i>',
      to: "/add-new-post",
    },
    {
      title: "Forms & Components",
      htmlBefore: '<i class="material-icons">view_module</i>',
      to: "/components-overview",
    },
    {
      title: "Tables",
      htmlBefore: '<i class="material-icons">table_chart</i>',
      to: "/tables",
    },
    {
      title: "User Profile",
      htmlBefore: '<i class="material-icons">person</i>',
      to: "/user-profile-lite",
    },
    {
      title: "Errors",
      htmlBefore: '<i class="material-icons">error</i>',
      to: "/errors",
    },
    {
      title: "Icons",
      htmlBefore: '<i class="material-icons">adjust</i>',
      to: "https://material.io/resources/icons/?style=baseline",
    }*/
    
  ];
}
